import { Component, OnInit } from '@angular/core'
import { IonRouterOutlet } from '@ionic/angular/standalone'

import { AuthenticatedLayoutService } from './authenticated-layout.service'

@Component({
	selector: 'app-authenticated-layout',
	templateUrl: './authenticated-layout.component.html',
	standalone: true,
	imports: [IonRouterOutlet],
})
export class AuthenticatedLayoutComponent implements OnInit {
	constructor(private readonly authenticatedLayoutService: AuthenticatedLayoutService) {}

	ngOnInit() {
		this.authenticatedLayoutService.initializeApp()
	}
}
